import { Button, FixedFooter } from "@/components/ui"
import { ReactNode } from "react"
import { createPortal } from "react-dom"
import { HelpHint } from "./HelpHint"

type StepFooterProps = {
  onBack?: () => void
  onContinue?: () => void
  continueLabel?: string
  continueDisabled?: boolean
  continueHint?: string
  continueLoading?: boolean
  rightSlot?: ReactNode
  showBack?: boolean
  backLabel?: string
}

export function StepFooter({
  onBack,
  onContinue,
  continueLabel = "Continuar",
  continueDisabled = false,
  continueHint,
  continueLoading = false,
  rightSlot,
  showBack = true,
  backLabel = "Voltar",
}: StepFooterProps) {
  return createPortal(
    <FixedFooter>
      <HelpHint message={continueDisabled ? continueHint : undefined} />
      <div className="flex gap-2 sm:gap-3 items-stretch">
        {showBack ? (
          <Button
            variant="outline"
            tone="neutral"
            size="lg"
            onClick={onBack}
            className="basis-1/3 shrink-0 whitespace-nowrap"
          >
            {backLabel}
          </Button>
        ) : null}
        {rightSlot ?? (
          <Button
            size="lg"
            onClick={onContinue}
            disabled={continueDisabled}
            isLoading={continueLoading}
            className="flex-1 whitespace-nowrap"
          >
            {continueLoading ? "Aguarde..." : continueLabel}
          </Button>
        )}
      </div>
    </FixedFooter>,
    document.body,
  )
}
